const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '无需翻页，纵向滚动即可连续阅读韩漫免费漫画，沉浸体验流畅如丝。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载韩漫每日更新，与韩国同步的追更节奏，第一时间阅读最新章节。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量韩漫资源',
    desc: '超过10,000部韩漫免费漫画，覆盖恋爱、奇幻、悬疑、动作、校园等多元题材。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台畅读',
    desc: '支持桌面端、移动端及APP多端阅读，随时随地享受韩漫免费阅读乐趣。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净体验',
    desc: '无弹窗广告骚扰，纯净阅读环境，专注为韩漫爱好者提供优质的在线阅读服务。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 text-center hover:border-primary-200 transition-colors duration-300"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}